import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DataTableComponent} from './components/data-table.component';
import {PaginationComponent} from './components/pagination.component';
import {NotificationComponent} from './components/notification.component';
import {RouterModule} from '@angular/router';
import {MatInputModule} from '@angular/material';
import {DebounceDirective} from './directives/debounce.directive';
import {ActionsDropdownComponent} from './components/actions-dropdown.component';
import {SortPipe} from './pipes/sort.pipe';
import {FileUploadComponent} from './components/file-upload.component';
import {SubareaComponent} from './components/subarea.component';
import {ArrayJoinPipe} from './pipes/arrayJoin.pipe';
import {ForPipe} from './pipes/for.pipe';
import {MessagesComponent} from '../features/assistenza/components/modals/messages.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EditorComponent} from './components/editor.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {FotoItemComponent} from './components/foto-item.component';
import {SearchBoxComponent} from './components/search-box.component';
import {ScalaAlopeciaComponent} from './components/scala-alopecia.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {ProductsNameListPipe} from './pipes/products-name-list.pipe';
import {SwitchComponent} from './components/switch.component';
import {DobComponent} from './components/dob.component';
import {DatetimePickerComponent} from './components/datetime-picker.component';
import {DpDatePickerModule} from 'ng2-date-picker';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {DurataPipe} from './pipes/durata.pipe';
import {DateFormatPipe} from './pipes/dateformat.pipe';
import {ProductsSelectorComponent} from './components/products-selector.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgCanModule} from './directives/ng-can.module';
import {AutoResizeDirective} from './directives/auto-resize.directive';
import {LaravelErrorsComponent} from './components/laravel-errors.component';
import {SelectDateModalComponent} from './components/select-date-modal.component';
import {CalendarModule} from 'angular-calendar';
import {LineeProdottoSelectorComponent} from './components/linee-prodotto-selector.component';
import {GoogleDatePickerComponent} from './components/google-date-picker.component';
import {StatoLabelPipe} from './pipes/statoLabel.pipe';
import {FieldDurataComponent} from './components/field-durata.component';
import {CicloTrattamentoModalComponent} from './components/ciclo-trattamento-modal.component';
import {ModalCalendarComponent} from "./components/modal-calendar.component";
import {ConfermaStatoCambioDatComponent} from "./components/conferma-stato-cambio-dat.component";
import {CopiaCicloModalComponent} from "./components/copia-ciclo-modal.component";
import {DisponibilitaMantenimentoComponent} from "./components/disponibilita-mantenimento.component";

const COMPONENTS = [
  DataTableComponent,
  PaginationComponent,
  NotificationComponent,
  ActionsDropdownComponent,
  FileUploadComponent,
  SubareaComponent,
  DebounceDirective,
  SortPipe,
  ArrayJoinPipe,
  ForPipe,
  MessagesComponent,
  EditorComponent,
  FotoItemComponent,
  SearchBoxComponent,
  ScalaAlopeciaComponent,
  ProductsNameListPipe,
  DurataPipe,
  DobComponent,
  DatetimePickerComponent,
  DateFormatPipe,
  ProductsSelectorComponent,
  SwitchComponent,
  AutoResizeDirective,
  LaravelErrorsComponent,
  SelectDateModalComponent,
  LineeProdottoSelectorComponent,
  GoogleDatePickerComponent,
  StatoLabelPipe,
  FieldDurataComponent,
  CicloTrattamentoModalComponent,
  ModalCalendarComponent,
  ConfermaStatoCambioDatComponent,
  CopiaCicloModalComponent,
  DisponibilitaMantenimentoComponent,
];

@NgModule({
  providers: [ProductsNameListPipe],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS, NgCanModule],
  imports: [
    CommonModule,
    RouterModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgSelectModule,
    DpDatePickerModule,
    NgbModalModule,
    DragDropModule,
    CalendarModule,
    NgCanModule,
  ],
  entryComponents: [
    MessagesComponent,
    SelectDateModalComponent,
    CicloTrattamentoModalComponent,
    ConfermaStatoCambioDatComponent,
    CopiaCicloModalComponent,
  ]
})
export class SharedModule {
}
